import React from 'react';
import { useAuth } from '../../hooks/useAuth';

export default function PermissionWrapper({ permission, requiredPermissions, mode = 'any', fallback = null, children }) {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = useAuth();
  let ok = true;
  if (permission) ok = hasPermission(permission);
  else if (Array.isArray(requiredPermissions)) ok = mode === 'all' ? hasAllPermissions(requiredPermissions) : hasAnyPermission(requiredPermissions);
  return ok ? children : fallback || null;
}
